<template>
    <div class="h-full w-full flex flex-col">
        <div class="h-full container mx-auto">
            <div class="px-8 flex flex-col h-full w-full py-8">
                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <div class="flex items-center text-sm font-light">
                        <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
                        <span class="mx-2">/</span>
                        <router-link to="/employment" class="opacity-50 hover:opacity-100">Employment</router-link>
                        <span class="mx-2">/</span>
                        <span>Booking Interviews</span>
                    </div>
                    <div class="font-bold">Booking Interviews</div>
                </div>
                <section class="mt-8 h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="flex justify-between flex-wrap">
                        <h1 class="text-base md:text-lg font-semibold mb-4">Interviews List</h1>
                        <div class="flex justify-start items-center flex-wrap">
                            <div v-if="role == 'admin' || role == 'superadmin' || role == 'careercounselor'"
                                class="w-full sm:w-auto mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Employer:</div>
                                <select v-model="filterByPartner" class="outline-none text-sm w-full sm:w-auto">
                                    <option value="">All Employers</option>
                                    <option :value="item.id" v-for="(item, index) in partnersList" :key="index">{{
                                        item.en_company_name }}</option>
                                </select>
                            </div>
                            <div class="w-full sm:w-auto ml-0 sm:ml-8 mb-4">
                                <search @on-search="onSearch" class-list="px-4 h-8"></search>
                            </div>
                            <div v-if="hasPermission('booking-interviews-create')" @click.stop="createModal = true"
                                class="flex items-center bg-ternary hover:bg-white border-ternary border px-4 py-2 rounded-lg cursor-pointer text-white hover:text-ternary">
                                <icon-plus class="w-4 h-4"></icon-plus>
                                <span class="text-xs ml-2">Book Interview</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col" v-if="$apollo.queries.interviews.loading">
                        <table-shimmer
                            :titleHeaders="['#', 'Position', 'Field of Job', 'Interview Through', 'Candidates Count', 'Actions']"
                            :rows="first"></table-shimmer>
                    </div>
                    <div v-else-if="!$apollo.queries.interviews.loading && !hasItems"
                        class="h-full flex justify-center items-center">
                        <h1 class="text-center text-xl font-medium">No interviews found!</h1>
                    </div>
                    <div v-else class="flex flex-col">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <table class="min-w-full text-left text-sm font-light">
                                        <thead class="border-b font-medium dark:border-neutral-500">
                                            <tr>
                                                <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Position</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Field of Job</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Interview Type</th>
                                                <th v-if="role == 'admin' || role == 'superadmin' || role == 'careercounselor'"
                                                    scope="col" class="px-6 py-2 text-gray-400">Partner</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400 text-center">Candidates
                                                    Count</th>
                                                <th v-if="role == 'partner'" scope="col"
                                                    class="px-6 py-2 text-gray-400">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in items" :key="index"
                                                class="border-b border-dashed dark:border-neutral-500">
                                                <td class="whitespace-nowrap px-6 py-2 font-medium">{{
                                                    paginatorInfo.firstItem + index }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ item.job.position_name }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ item.field_of_job }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    <div class="flex flex-col">
                                                        <div>{{ item.interview_through }}</div>
                                                        <div v-if="item.interview_through == 'virtual interview'">
                                                            <a :href="item.meeting_link" target="_blank"
                                                                class="text-blue-600 hover:underline">{{
                                                                    item.meeting_link }}</a>
                                                        </div>
                                                        <div v-else>
                                                            {{ item.location }}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td v-if="role == 'admin' || role == 'superadmin' || role == 'careercounselor'"
                                                    class="whitespace-nowrap px-6 py-2">{{
                                                        item.job.partner.en_company_name }}</td>
                                                <td class="whitespace-nowrap px-6 py-2 text-center">
                                                    <span v-if="item.interview_candidates.length > 0"
                                                        @click.stop="showStudentsList(item.id, item.group_name)"
                                                        class="hover:underline hover:text-blue-600 cursor-pointer"
                                                        title="Click to view the students list">{{
                                                            item.interview_candidates.length }}</span>
                                                    <span v-else>0</span>
                                                </td>
                                                <td v-if="role == 'partner'" class="px-6 py-2">
                                                    <div class="flex">
                                                        <!-- <div v-if="hasPermission('booking-interviews-show')" @click.stop="viewItem(item)" class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-eye class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                                                        </div> -->
                                                        <div v-if="hasPermission('booking-interviews-edit')"
                                                            @click.stop="editItem(item)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-pen
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-pen>
                                                        </div>
                                                        <div v-if="hasPermission('booking-interviews-delete')"
                                                            @click.stop="deleteItem(item.id)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer">
                                                            <icon-trash
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-trash>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
                        </div>
                    </div>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="createModal" :title="`Book Interview`" @close="closeModal">
                            <create @created="onCreated" @close="closeModal" @view-student-profile="viewStudentProfile">
                            </create>
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="editModal" :title="`Edit Interview`" @close="closeModal">
                            <edit @updated="onUpdated" @close="closeModal" :selected-item="selectedItem"></edit>
                        </base-modal>
                    </transition>

                    <!-- <transition name="fade" mode="out-in">
                        <base-modal v-if="isViewItem" :title="`View Job - #${selectedItem.id}`" height="" @close="closeModal">
                            <apply-job :item="selectedItem" user-type="partner" @close="closeModal"></apply-job>
                        </base-modal>
                    </transition> -->

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="isShowCandidates"
                            :title="`Interview - ${selectedInterviewGroupName} - Students List`" height=""
                            @close="closeModal">
                            <interview-candidates :interview-id="selectedInterviewId"
                                @close="closeModal"></interview-candidates>
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-full-modal v-if="showFullModal" title="Student Profile" @close="closeFullModal">
                            <student-profile :student-id="studentId"></student-profile>
                        </base-full-modal>
                    </transition>

                </section>
            </div>
        </div>
    </div>
</template>

<script>
// import IconEye from "../../../components/icons/IconEye.vue";
import IconPen from "../../../components/icons/IconPen.vue";
import IconTrash from "../../../components/icons/IconTrash.vue";
import IconPlus from "../../../components/icons/IconPlus.vue";
import gql from 'graphql-tag';
import Pagination from "../../../components/shared/pagination.vue";
import TableShimmer from '../../../components/shared/TableShimmer.vue';
import Create from "./create.vue";
import Edit from "./edit.vue";
import InterviewCandidates from "./interview-candidates.vue";
import { formattedDateWithTimeAmPm } from "../../../helpers/utils";
import StudentProfile from "../../student-profile/index.vue";
import Search from "../../../components/shared/search.vue";
export default {
    name: "booking-interviews-index",
    components: {
        // IconEye,
        IconPen,
        IconTrash,
        IconPlus,
        Pagination,
        TableShimmer,
        Create,
        Edit,
        InterviewCandidates,
        StudentProfile,
        Search,
    },
    data() {
        return {
            interviews: [],
            first: 10,
            page: 1,
            createModal: false,
            editModal: false,
            isViewItem: false,
            modalTitle: "",
            selectedItem: null,
            error: null,
            isShowCandidates: false,
            selectedInterviewId: null,
            selectedInterviewGroupName: null,
            showFullModal: false,
            studentId: null,
            filterByPartner: "",
            partnersList: [],
            searchText: "",
        };
    },
    watch: {
        searchText() {
            this.page = 1;
        },
        interviews(newVal) {
            if (newVal.error) {
                if (newVal.error_code == 403) {
                    this.$router.replace('/no-permission');
                } else if (newVal.error_code == 401) {
                    this.$router.replace('/');
                } else {
                    alert(newVal.message);
                    this.$router.replace('/');
                }
            }
        },
        filterByPartner() {
            this.page = 1;
        },
    },
    computed: {
        items() {
            return this.interviews.data;
        },
        hasItems() {
            if (this.items && this.items.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        paginatorInfo() {
            return this.interviews.paginatorInfo;
        },
        role() {
            return this.$store.getters.role;
        },
    },
    created() {
        if (this.role == 'admin' || this.role == 'superadmin' || this.role == 'careercounselor') {
            this.getPartnersList();
        }
    },
    apollo: {
        interviews() {
            return {
                query: gql`query GetAllInterviews($first: Int!, $page: Int!, $filter_by_partner: Int, $search: String) {
                    interviews(first: $first, page: $page, filter_by_partner: $filter_by_partner, search: $search) {
                        error
                        error_code
                        message
                        data {
                            id
                            job_id
                            group_name
                            field_of_job
                            interview_through
                            meeting_link
                            location
                            supervisor
                            interview_candidates {
                                start_date_and_time
                                end_date_and_time
                                user {
                                    id
                                    name
                                    email
                                    students {
                                        student_id
                                    }
                                }
                            }
                            job {
                                position_name
                                partner {
                                    en_company_name
                                }
                            }
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }`,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                        filter_by_partner: parseInt(this.filterByPartner),
                        search: this.searchText,
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        onSearch(searchText) {
            this.searchText = searchText;
        },
        getInterviewDateTime(date) {
            return formattedDateWithTimeAmPm(date);
        },
        setPage(page) {
            this.page = page;
        },
        closeModal() {
            this.createModal = false;
            this.editModal = false;
            this.isViewItem = false;
            this.modalTitle = "";
            this.selectedItem = null;
            this.isShowCandidates = false
            this.selectedInterviewId = null;
            this.selectedInterviewGroupName = null;
        },
        showToast(message = '') {
            this.$apollo.queries.interviews.refetch();
            const Toast = this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            })
            Toast.fire({
                icon: 'success',
                title: message
            })
            this.closeModal();
        },
        onCreated() {
            this.showToast('Interview Created Successfully');
        },
        editItem(item) {
            this.selectedItem = item;
            this.editModal = true;
        },
        async deleteItem(id) {

            this.$swal.fire({
                title: 'Are you sure?',
                text: "Do you want to delete this interview? You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {

                    const DELETE_MUTATION = gql`
                        mutation DeleteInterview($id: ID!) {
                            deleteInterview(id: $id) {
                                error
                                message
                            }
                        }
                    `;

                    try {
                        await this.$apollo.mutate({
                            mutation: DELETE_MUTATION,
                            variables: {
                                id: id,
                            }
                        }).then((data) => {
                            if (data.data.deleteInterview.error) {
                                this.error = data.data.deleteInterview.message;
                            }
                        }).catch((error) => {
                            this.error = error.message;
                        })

                    } catch (error) {
                        this.error = error.message || "Please try again.";
                    }

                    if (this.error === null) {
                        this.showToast('Your interview has been deleted.');
                    } else {
                        this.$swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: this.error,
                        }).then((result) => {
                            if (result.value || result.dismiss) {
                                this.error = null
                            }
                        })
                    }

                }
            })

        },
        onUpdated() {
            this.showToast('Interview Updated Successfully');
        },
        hasPermission(crudName) {
            const permissions = this.$store.getters.permissions;
            const permissionsArray = permissions.split(",");
            if (permissionsArray.includes(crudName)) {
                return true;
            } else {
                return false;
            }
        },
        showStudentsList(id, groupName) {
            this.selectedInterviewId = id;
            this.selectedInterviewGroupName = groupName;
            this.isShowCandidates = true;
        },
        viewItem(item) {
            this.selectedItem = item;
            this.isViewItem = true;
        },
        viewStudentProfile(studentId) {
            this.studentId = studentId;
            this.showFullModal = true;
        },
        closeFullModal() {
            this.showFullModal = false;
            this.studentId = null;
        },
        async getPartnersList() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                        query GetActivePartnersList {
                            activePartners {
                                data {
                                    id
                                    en_company_name
                                }
                            }
                        }
                    `,
                    fetchPolicy: 'network-only',
                });
                this.partnersList = data.activePartners.data;
            } catch (error) {
                console.log(error);
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>